export enum BotChatCardType {
  MESSAGE = 'text',
  CONFIRMATION = 'confirmation',
  SELECT = 'select',
  MULTISELECT = 'multiselect',
  ORDER_SUMMARY = 'order-summary',
  TIME_SLOT = 'time-slot',
}
